// src/actions/hdfcCardUPActions.js
import axios from "axios";
import {
  GET_ALL_HDFC_CARD_UP_REQUEST,
  GET_ALL_HDFC_CARD_UP_SUCCESS,
  GET_ALL_HDFC_CARD_UP_FAIL,
  CREATE_HDFC_CARD_UP_REQUEST,
  CREATE_HDFC_CARD_UP_SUCCESS,
  CREATE_HDFC_CARD_UP_FAIL,
  UPDATE_HDFC_CARD_UP_REQUEST,
  UPDATE_HDFC_CARD_UP_SUCCESS,
  UPDATE_HDFC_CARD_UP_FAIL,
  DELETE_HDFC_CARD_UP_REQUEST,
  DELETE_HDFC_CARD_UP_SUCCESS,
  DELETE_HDFC_CARD_UP_FAIL,
  BULK_DELETE_HDFC_CARD_UP_REQUEST,
  BULK_DELETE_HDFC_CARD_UP_SUCCESS,
  BULK_DELETE_HDFC_CARD_UP_FAIL,
  IMPORT_HDFC_CARD_UP_REQUEST,
  IMPORT_HDFC_CARD_UP_SUCCESS,
  IMPORT_HDFC_CARD_UP_FAIL,
  EXPORT_HDFC_CARD_UP_REQUEST,
  EXPORT_HDFC_CARD_UP_SUCCESS,
  EXPORT_HDFC_CARD_UP_FAIL,
  GET_HDFC_CARD_UP_DEPARTMENTS_REQUEST,
  GET_HDFC_CARD_UP_DEPARTMENTS_SUCCESS,
  GET_HDFC_CARD_UP_DEPARTMENTS_FAIL,
} from "../constants/hdfcCardUPConstants";
import { logout } from "./userActions";

const baseUrl = process.env.REACT_APP_API_URL;

// Get HDFC Card UP records with pagination and search
export const getHdfcCardUPRecords =
  (queryParams = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ALL_HDFC_CARD_UP_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `${baseUrl}/hdfc-cards-up${queryParams ? `?${queryParams}` : ""}`,
        config,
      );

      dispatch({
        type: GET_ALL_HDFC_CARD_UP_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: GET_ALL_HDFC_CARD_UP_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Get HDFC Card UP Departments
export const getHdfcCardUPDepartments = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_HDFC_CARD_UP_DEPARTMENTS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${baseUrl}/hdfc-cards-up/departments`,
      config,
    );

    dispatch({
      type: GET_HDFC_CARD_UP_DEPARTMENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_HDFC_CARD_UP_DEPARTMENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Create new HDFC Card UP record
export const createHdfcCardUPRecord =
  (recordData) => async (dispatch, getState) => {
    try {
      dispatch({ type: CREATE_HDFC_CARD_UP_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `${baseUrl}/hdfc-cards-up`,
        recordData,
        config,
      );

      dispatch({
        type: CREATE_HDFC_CARD_UP_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: CREATE_HDFC_CARD_UP_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Update HDFC Card UP record
export const updateHdfcCardUPRecord =
  (id, recordData) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_HDFC_CARD_UP_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `${baseUrl}/hdfc-cards-up/${id}`,
        recordData,
        config,
      );

      dispatch({
        type: UPDATE_HDFC_CARD_UP_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: UPDATE_HDFC_CARD_UP_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Delete HDFC Card UP record
export const deleteHdfcCardUPRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_HDFC_CARD_UP_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${baseUrl}/hdfc-cards-up/${id}`, config);

    dispatch({
      type: DELETE_HDFC_CARD_UP_SUCCESS,
      payload: id,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: DELETE_HDFC_CARD_UP_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Bulk delete HDFC Card UP records
export const bulkDeleteHdfcCardUPRecords =
  (ids) => async (dispatch, getState) => {
    try {
      dispatch({ type: BULK_DELETE_HDFC_CARD_UP_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `${baseUrl}/hdfc-cards-up/bulk-delete`,
        { ids },
        config,
      );

      dispatch({
        type: BULK_DELETE_HDFC_CARD_UP_SUCCESS,
        payload: { deletedCount: data.deletedCount },
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: BULK_DELETE_HDFC_CARD_UP_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Import HDFC Card UP records from file
export const importHdfcCardUPRecords =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: IMPORT_HDFC_CARD_UP_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `${baseUrl}/hdfc-cards-up/import`,
        formData,
        config,
      );

      dispatch({
        type: IMPORT_HDFC_CARD_UP_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: IMPORT_HDFC_CARD_UP_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Export HDFC Card UP records to file
export const exportHdfcCardUPRecords = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EXPORT_HDFC_CARD_UP_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: "blob",
    };

    const { data } = await axios.get(`${baseUrl}/hdfc-cards-up/export`, config);

    // Create download link
    const url = URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "HdfcCardUP_Export.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);

    dispatch({
      type: EXPORT_HDFC_CARD_UP_SUCCESS,
      payload: "Export completed successfully",
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: EXPORT_HDFC_CARD_UP_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Sync HDFC Card UP Task Status
export const syncHdfcCardUPTaskStatus = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "SYNC_HDFC_CARD_UP_TASK_STATUS_REQUEST",
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const { data } = await axios.post(
      `${baseUrl}/hdfc-cards-up/sync-task-status`,
      {},
      config,
    );

    dispatch({
      type: "SYNC_HDFC_CARD_UP_TASK_STATUS_SUCCESS",
      payload: data,
    });

    return data; // Return data including updatedRecords
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: "SYNC_HDFC_CARD_UP_TASK_STATUS_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

// Get Field Executives for HDFC Card UP
export const getFieldExecutivesUP =
  (search = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: "GET_FIELD_EXECUTIVES_UP_REQUEST",
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const { data } = await axios.get(
        `${baseUrl}/hdfc-cards-up/field-executives?search=${encodeURIComponent(search)}`,
        config,
      );

      dispatch({
        type: "GET_FIELD_EXECUTIVES_UP_SUCCESS",
        payload: data,
      });

      return data; // Return the data
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
        return;
      }
      dispatch({
        type: "GET_FIELD_EXECUTIVES_UP_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      throw error; // Throw error so it can be caught
    }
  };
